import UseCase, { NoParams } from "../../core/useCase/UseCase";
import { UserRepository } from "../repository/UserRepository";

/**
 * Seconds remaining before the member's credential expires. Used only by the
 * renewal clock (PPI-1848) to decide when to ask the auth service for a
 * rotation — never to decide when to sign the member out, which is idle
 * time's job and lives in the Session domain.
 */
export default class GetTokenRemainingSeconds extends UseCase<
  number,
  NoParams
> {
  repository: UserRepository;

  constructor(repository: UserRepository) {
    super();
    this.repository = repository;
  }

  execute = () => this.repository.getTokenRemainingSeconds();
}
